import carSvg from '../../../assets/car.svg';
import greenCarSvg from '../../../assets/car-green.svg';

const icons = [carSvg, carSvg, greenCarSvg, carSvg, carSvg];

const CarIcons = () => {
    return (
        <div className="flex flex-wrap items-center gap-4">
            {icons.map((icon, index) => (
                <img 
                    key={index} 
                    src={icon} 
                    alt={`car-icon-${index}`} 
                    className="w-5 h-5"
                />
            ))}
        </div>
    );
}

export default CarIcons;